import { render, staticRenderFns } from "./btn-inline-icon.mpx?vue&type=template&id=62d749a4&isComponent&outputPath=components%2Fbtn-inline-iconed283dfc%2Findex"
import script from "./btn-inline-icon.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-inline-iconed283dfc%2Findex"
export * from "./btn-inline-icon.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-inline-iconed283dfc%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports